var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "add_a_photo-24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 95,
    height: 98,
    viewBox: "0 0 95 98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1637",
    "data-name": "Rectangle 1637",
    width: 95,
    height: 98,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M11.553,12.12V1h7.7V12.12H30.809v7.413H19.256v11.12h-7.7V19.533H0V12.12ZM23.107,34.36V23.24H34.66V12.12H61.619l7.048,7.413H80.874a7.584,7.584,0,0,1,7.7,7.413v44.48a7.584,7.584,0,0,1-7.7,7.413H19.256a7.584,7.584,0,0,1-7.7-7.413V34.36ZM50.065,67.72c10.629,0,19.256-8.3,19.256-18.533S60.694,30.653,50.065,30.653s-19.256,8.3-19.256,18.533S39.436,67.72,50.065,67.72ZM37.741,49.187A12.333,12.333,0,1,0,50.065,37.325,12.086,12.086,0,0,0,37.741,49.187Z",
    transform: "translate(0 5.503)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageUpload);
export default __webpack_public_path__ + "static/media/image-upload.1da64168.svg";
export { ForwardRef as ReactComponent };